import ContentDetailsHeader from './ContentDetailsHeader';
export type { ContentDetailsHeaderProps } from './ContentDetailsHeader.types';

export default ContentDetailsHeader;
